module.exports = __webpack_public_path__ + "static/media/staticmap.222e2b01.png";